import { $can } from '@pendo/permissions';

export function hasManagementAccessForAppIds (ids) {
    return ids.some(hasManagementAccessForAppId);
}

export function hasManagementAccessForAppId (id) {
    return $can(id)
        .entity('applicationDetails')
        .action('view')
        || $can(id)
            .entity('installationSettings')
            .action('view')
        || $can(id)
            .entity('rawEvent')
            .action('view');
}
